<app-client-layout>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0">VM Details</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
              <li class="breadcrumb-item"><a href="javascript: void(0);" (click)="goBack()">VMs</a></li>
              <li class="breadcrumb-item active">Details</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading VM details...</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="error">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>
    </div>

    <div class="row" *ngIf="successMessage">
      <div class="col-12">
        <div class="alert alert-success" role="alert">
          {{ successMessage }}
        </div>
      </div>
    </div>

    <div class="row" *ngIf="vm">
      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="card-title">{{ vm.name }}</h4>
              <span class="badge" [ngClass]="getVMStatusClass(vm.status)">{{ vm.status }}</span>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>VM ID</strong></td>
                        <td>{{ vm.id }}</td>
                      </tr>
                      <tr>
                        <td><strong>Type</strong></td>
                        <td>{{ vm.type.toUpperCase() }}</td>
                      </tr>
                      <tr>
                        <td><strong>Node</strong></td>
                        <td>{{ vm.node }}</td>
                      </tr>
                      <tr>
                        <td><strong>IP Address</strong></td>
                        <td>{{ vm.ipAddress }}</td>
                      </tr>
                      <tr>
                        <td><strong>Created</strong></td>
                        <td>{{ vm.createdAt | date:'medium' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>CPU</strong></td>
                        <td>{{ vm.cpu }} vCPU</td>
                      </tr>
                      <tr>
                        <td><strong>Memory</strong></td>
                        <td>{{ vm.memory }} MB</td>
                      </tr>
                      <tr>
                        <td><strong>Disk</strong></td>
                        <td>{{ vm.disk }} GB</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- VM Configuration -->
        <div class="card" *ngIf="vmConfig">
          <div class="card-body">
            <h4 class="card-title mb-4">Configuration</h4>
            
            <div class="row">
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>OS Type</strong></td>
                        <td>{{ vmConfig.ostype || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Boot Device</strong></td>
                        <td>{{ vmConfig.boot || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Agent</strong></td>
                        <td>{{ vmConfig.agent ? 'Enabled' : 'Disabled' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>BIOS</strong></td>
                        <td>{{ vmConfig.bios || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Machine</strong></td>
                        <td>{{ vmConfig.machine || 'N/A' }}</td>
                      </tr>
                      <tr>
                        <td><strong>SCSI Controller</strong></td>
                        <td>{{ vmConfig.scsihw || 'N/A' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Resource Usage -->
        <div class="card" *ngIf="vmStatus">
          <div class="card-body">
            <h4 class="card-title mb-4">Resource Usage</h4>
            
            <div class="row">
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>CPU Usage</strong></td>
                        <td>{{ (vmStatus.cpu * 100).toFixed(2) }}%</td>
                      </tr>
                      <tr>
                        <td><strong>Memory Usage</strong></td>
                        <td>{{ (vmStatus.mem / 1024 / 1024).toFixed(2) }} MB / {{ (vmStatus.maxmem / 1024 / 1024).toFixed(2) }} MB</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td><strong>Disk Usage</strong></td>
                        <td>{{ (vmStatus.disk / 1024 / 1024 / 1024).toFixed(2) }} GB / {{ (vmStatus.maxdisk / 1024 / 1024 / 1024).toFixed(2) }} GB</td>
                      </tr>
                      <tr>
                        <td><strong>Network</strong></td>
                        <td>{{ (vmStatus.netin / 1024 / 1024).toFixed(2) }} MB in / {{ (vmStatus.netout / 1024 / 1024).toFixed(2) }} MB out</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Actions</h4>
            
            <div class="d-grid gap-2">
              <button type="button" class="btn btn-success waves-effect waves-light" 
                      *ngIf="vm.status !== 'running'" (click)="onStartVM()">
                <i class="mdi mdi-play me-1"></i> Start VM
              </button>
              
              <button type="button" class="btn btn-warning waves-effect waves-light" 
                      *ngIf="vm.status === 'running'" (click)="onStopVM()">
                <i class="mdi mdi-stop me-1"></i> Stop VM
              </button>
              
              <button type="button" class="btn btn-info waves-effect waves-light" 
                      *ngIf="vm.status === 'running'" (click)="onRestartVM()">
                <i class="mdi mdi-restart me-1"></i> Restart VM
              </button>
              
              <button type="button" class="btn btn-secondary waves-effect waves-light" 
                      *ngIf="vm.status === 'running'" (click)="onPauseVM()">
                <i class="mdi mdi-pause me-1"></i> Pause VM
              </button>
              
              <button type="button" class="btn btn-secondary waves-effect waves-light" 
                      *ngIf="vm.status === 'paused'" (click)="onResumeVM()">
                <i class="mdi mdi-play me-1"></i> Resume VM
              </button>
              
              <button type="button" class="btn btn-danger waves-effect waves-light mt-3" (click)="onDeleteVM()">
                <i class="mdi mdi-delete me-1"></i> Delete VM
              </button>
            </div>
          </div>
        </div>
        
        <!-- Network Information -->
        <div class="card" *ngIf="vmStatus && vmStatus.net0">
          <div class="card-body">
            <h4 class="card-title mb-4">Network</h4>
            
            <div class="table-responsive">
              <table class="table table-borderless mb-0">
                <tbody>
                  <tr>
                    <td><strong>net0</strong></td>
                    <td>{{ vmStatus.net0 }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-client-layout>